import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const StarOutline = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M41.223,22.388c0.497,-0.487 0.777,-1.152 0.777,-1.848c0,-1.277 -0.947,-2.372 -2.211,-2.556l-8.717,-1.267c-0.371,-0.054 -0.692,-0.288 -0.857,-0.624l-3.898,-7.898c-0.434,-0.88 -1.334,-1.439 -2.316,-1.439c-0.981,0 -1.88,0.559 -2.314,1.439l-3.899,7.898c-0.165,0.336 -0.488,0.57 -0.86,0.624l-8.717,1.267c-1.264,0.184 -2.211,1.279 -2.211,2.556c0,0.696 0.28,1.361 0.777,1.848l6.316,6.149c0.268,0.262 0.391,0.64 0.328,1.011l-1.478,8.681c-0.135,0.747 0.072,1.516 0.565,2.094c0.784,0.918 2.108,1.18 3.183,0.625l7.794,-4.099c0.334,-0.166 0.728,-0.166 1.062,0l7.798,4.099c0.37,0.196 0.782,0.297 1.2,0.296c0.764,-0.001 1.49,-0.341 1.98,-0.928c0.492,-0.577 0.7,-1.345 0.564,-2.092l-1.477,-8.683c-0.064,-0.369 0.059,-0.748 0.328,-1.01l6.283,-6.143Z" fill={"none"} stroke={fill} strokeWidth={"2.96px"} />
    </svg>
  );
};

StarOutline.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

StarOutline.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
